import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STEPS, UI } from "@/data/content";

const Step = ({ step, index, lang }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0]);
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const textY = useTransform(scrollYProgress, [0.1, 0.45], [70, 0]);
  const textOpacity = useTransform(scrollYProgress, [0.12, 0.4, 0.75, 0.95], [0, 1, 1, 0]);
  const alignLeft = index % 2 === 0;

  return (
    <section ref={ref} data-testid={`step-${index + 1}`} className="relative min-h-[95vh] flex items-center overflow-hidden">
      <motion.div style={{ opacity }} className="absolute inset-0">
        <motion.img src={step.img} alt="" style={{ y: imgY }} className={`absolute inset-x-0 -top-[10%] w-full h-[120%] object-cover brightness-110 ${step.pos === "top" ? "object-top" : "object-center"}`} />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0809] via-[#0D0809]/60 to-[#0D0809]" />
        <div className="absolute inset-0 bg-[#7E2438]/10 mix-blend-multiply" />
      </motion.div>
      <motion.div
        style={{ y: textY, opacity: textOpacity }}
        className={`relative z-10 max-w-2xl px-6 sm:px-12 md:px-20 ${alignLeft ? "mr-auto" : "ml-auto md:text-right"}`}
      >
        <div className={`font-mono text-xs tracking-[0.3em] text-[#B03A52] ${alignLeft ? "" : "md:flex md:justify-end"}`}>
          {String(index + 1).padStart(2, "0")} / 07
        </div>
        <div className={`w-16 h-px bg-[#B03A52] my-6 ${alignLeft ? "" : "md:ml-auto"}`} />
        <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif text-[#F4EFEA]">{step.title[lang]}</h2>
        {step.text[lang] && <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#A89A9E]">{step.text[lang]}</p>}
      </motion.div>
    </section>
  );
};

export default function ScrollySteps({ lang }) {
  const t = UI[lang];
  return (
    <div id="story" data-testid="scrolly-steps" className="relative">
      <div className="px-6 sm:px-12 md:px-20 pt-24 pb-4">
        <span className="font-mono text-xs tracking-[0.3em] uppercase text-[#B03A52]">{t.stepsEyebrow}</span>
      </div>
      {STEPS.map((step, i) => (
        <Step key={i} step={step} index={i} lang={lang} />
      ))}
    </div>
  );
}
